import styled from "styled-components"

export const ListItem = styled.li`
  margin-bottom: 1rem;
`
